<script>

	import Company from '@/components/Company/Company'

	import './style.scss'

	export default {
		name: 'companies',
		props: [
			'companies'
		],
		components: {
			Company,
		},
		computed: {
			hasCompanies() {
				return this.companies.length > 0;
			}
		}
	}

</script>

<template>
	<div class='companies'>
		<header v-if='hasCompanies'>
			<h1>
				Choose a company!
			</h1>
		</header>
		<header v-else-if='!hasCompanies'>
			<h1>
				Loading...
			</h1>
		</header>
		<div class='container'>
			<Company
				v-for='company in companies'
				:key='company.subscriptionId'
				:company='company.company'
				:subscriptionId='company.subscriptionId'
				:subscriptionExpireDate='company.subscriptionExpireDate'
			/>
		</div>
	</div>
</template>



// WEBPACK FOOTER //
// src/components/Companies/Companies.vue